import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  // Subject to notify components when notifications should be refreshed
  private refreshNotifications$ = new Subject<void>();
  
  // Observable that components can subscribe to for refresh events
  notificationRefresh$ = this.refreshNotifications$.asObservable();
  
  constructor(private http: HttpClient) {}
  
  /**
   * Trigger a refresh of notifications in subscribed components
   */
  triggerRefresh(): void {
    this.refreshNotifications$.next();
  }

  /**
   * Mark a notification as read
   * @param notificationId - The ID of the notification to mark as read
   * @returns Observable<any>
   */
  markAsRead(notificationId: string): Observable<any> {
    return this.http.post<any>(API_ENDPOINTS.NOTIFICATION.MARK_AS_READ(notificationId), {});
  }

 MarkAsReadByTransactionCenter(referenceNo: string): Observable<any> {
  return this.http.post<any>(
    API_ENDPOINTS.NOTIFICATION.MARK_AS_READ_BY_REF,
    {
      refNo: referenceNo
    }
  );
}
  /**
   * Get paginated notifications
   * @param pageNumber - Page number (1-based)
   * @param pageSize - Number of items per page
   * @returns Observable<any>
   */
  getNotifications(pageNumber: number, pageSize: number): Observable<any> {
    return this.http.get<any>(API_ENDPOINTS.NOTIFICATION.GET_NOTIFICATIONS(pageNumber, pageSize));
  }

  /**
   * Get notifications by agent ID
   * @param agentId - The agent ID
   * @param pageNumber - Page number (1-based)
   * @param pageSize - Number of items per page
   * @param isRead - Filter by read status (10 for all, 0 for unread, 1 for read)
   * @returns Observable<any>
   */
  getNotificationsByAgent(agentId: string,locationId:string, pageNumber: number, pageSize: number, isRead: any): Observable<any> {
    return this.http.get<any>(API_ENDPOINTS.NOTIFICATION.GET_NOTIFICATIONS_BY_AGENT(agentId,locationId, pageNumber, pageSize, isRead));
  }

  /**
   * Get unread notification count
   * @returns Observable<any>
   */
  getUnreadCount(): Observable<any> {
    return this.http.get<any>(API_ENDPOINTS.NOTIFICATION.GET_UNREAD_COUNT);
  }
}
